export function formatDate(dateString, locale = 'en') {
  const options = { weekday: 'long', day: 'numeric', month: 'long' };
  return new Date(dateString).toLocaleDateString(locale, options);
}